<template>
	<div class="subscribe-wrap">
		<div class="subscribe">
			<h3 class="h3-24px">{{$t('subscribe.title')}}</h3>
			<p class="semibold-14px">{{$t('subscribe.desc')}}</p>
			<form @submit.prevent="submitForm">
				<input type="email" class="inp" v-model="email"
					:placeholder="$i18n.locale === 'zh' ? '输入你的邮箱' : 'Input your email'" required>
				<input type="submit" class="sub" :disabled="isDisabled">
			</form>
		</div>

		<div class="succ-pop" v-if="showSucc">
			<div class="pop-mask"></div>
			<div class="pop-con">
				<h3>{{$t('subscribe.succ')}}</h3>
				<a href="javascript:;" @click="toIndex">{{$t('subscribe.back')}}</a>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "subscribe",
	data() {
		return {
			isDisabled: false,
			showSucc: false,
			email: ''
		};
	},
	methods: {
		async submitForm() {
			this.isDisabled = true;
			const {data: res} = await this.$http.post(`${this.$baseUrl}/subscribe`, {
				email: this.email
			});
			if (res.meta.status != 200) return false;
			else {
				this.isDisabled = false;
				this.email = '';
				this.showSucc = true;
			}
		},
		toIndex() {
			this.showSucc = false;
			this.$router.push('/');
		}
	}
}
</script>

<style scoped lang="scss">
.succ-pop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
	.pop-mask {
		display: block;
		width: 100%;
		height: 100%;
		background-color: $black;
		opacity: 0.5;
	}
	.pop-con {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		background-color: #fff;
		border-radius: 10px;
		padding: 44px 40px;
		text-align: center;
		width: 480px;
		h3 {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: normal;
			font-size: 24px;
			line-height: 32px;
			margin-bottom: 38px;
		}
		a {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: normal;
			border-bottom: 1px solid $black;
			font-size: 16px;
			line-height: 150%;
		}
	}
}
//subscribe
.subscribe-wrap {
	padding: 44px 0;
	position: relative;
	background: url('~@/assets/images/row-bg2.jpg') no-repeat center center /
		cover;
	.bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		object-fit: cover;
	}
}
.subscribe {
	position: relative;
	z-index: 2;
	text-align: center;
	color: $white2;
	h3 {
		margin-bottom: 10px;
	}
	p {
		margin-bottom: 24px;
	}
	form {
		display: block;
		width: 380px;
		height: 62px;
		margin: 0 auto;
		position: relative;
		background: #ffffff;
		border-radius: 100px;
		.inp {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			border: none;
			background: none;
			padding-left: 24px;
			padding-right: 86px;
			font-size: 18px;
		}
		.sub {
			position: absolute;
			right: 0;
			top: 0;
			height: 100%;
			width: 62px;
			background: url(../assets/images/send.png) no-repeat center center /
				contain;
			border: none;
			font-size: 0;
		}
	}
}

@media only screen and (max-width: 767px) {
	.subscribe-wrap {
		background-image: url(~@/assets/images/row-bg2-2.jpg);
	}
	.subscribe form {
		height: 48px;
		margin: 0 20px;
		width: auto;
	}
	.subscribe form .sub {
		width: 48px;
	}
	.subscribe p {
		font-size: 12px;
	}
	.subscribe form .inp {
		font-size: 14px;
	}
	.succ-pop {
		.pop-con {
			padding: 40px 20px;
			width: 370px;
			h3 {
				font-size: 18px;
				line-height: 150%;
				margin-bottom: 26px;
			}
			a {
				font-size: 14px;
			}
		}
	}
}
</style>
